import React, { useState } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import dayjs from "dayjs";
import FilterDateInput from "../inputs/filterDateInput";

const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] });
const cacheLtr = createCache({ key: 'ltr' });

const TimeDropdown = ({
    selectedTime,
    setSelectedTime,
}) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();
    const [isCustom, setIsCustom] = useState(false);
    const [selectedDate, setSelectedDate] = useState({
        from: dayjs(),
        to: dayjs()
    });

    const handleDateChange = (date, type) => {
        const updatedDate = type === 'from'
            ? { from: date, to: selectedDate.to }
            : { from: selectedDate.from, to: date };

        const formattedDates = {
             from: updatedDate.from.toISOString(),
            to: updatedDate.to.toISOString(),
            time: ''
        };

        setSelectedDate(updatedDate);
        setSelectedTime(formattedDates);
    };

    const handleTime = (time) => {
        let returnStatment = '';
        switch (time) {
            case t("today"):
                returnStatment = "today";
                break;
            case t("yesterday"):
                returnStatment = "yesterday";
                break;
            case t("daybeforeyesterday"):
                returnStatment = "daybeforeyesterday";
                break;
            case t("week"):
                returnStatment = "week";
                break;
            case t("month"):
                returnStatment = "month";
                break;
            case t("custom"):
                returnStatment = "custom";
                break;
            default:
                returnStatment = '';
                break
        }

        return returnStatment;
    };

    const options = [
        t("today"),
        t("yesterday"),
        t("daybeforeyesterday"),
        t("week"),
        t("month"),
        t("custom")
    ];


    return (
        !isCustom ?
            <CacheProvider value={i18n.language === 'en' ? cacheLtr : cacheRtl}>
                <Autocomplete
                    options={options}
                    getOptionLabel={(option) => option}
                    value={selectedTime && selectedTime.value}
                    onChange={(event, newValue) => {
                        if (newValue === t('custom')) setIsCustom(true);
                        else {
                            if (!newValue)
                                setSelectedTime({ time: 'today', value: t('today') });
                            else
                                setSelectedTime({
                                    time: handleTime(newValue),
                                    value: newValue
                                });
                        }
                    }}
                    renderInput={(params) => (
                        <Box>
                            <TextField
                                {...params}
                                variant="standard"
                                fullWidth
                                placeholder={t("chooseTime")}
                                InputProps={{
                                    ...params.InputProps,
                                    disableUnderline: true,
                                    endAdornment: (
                                        <>
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                    style: {
                                        backgroundColor: "transparent",
                                        padding: "6px 8px",
                                    },
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            borderColor:
                                                theme.palette.customGrey.borderInput,
                                        },
                                        "&:hover fieldset": {
                                            borderColor:
                                                theme.palette.customGrey.borderInput,
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: theme.palette.primary.main,
                                        },
                                    },
                                    "& .MuiInputBase-input": {
                                        color: theme.palette.text.primary,
                                        padding: "6px 8px",
                                        "&::placeholder": {
                                            fontSize: "14px",
                                            color: theme.palette.text.secondary,
                                            opacity: 1,
                                        },
                                    },
                                }}
                            />
                        </Box>
                    )}
                />
            </CacheProvider>
            : <Box sx={{
                display: 'flex',
                alignItems: 'center'
            }}>
                <FilterDateInput
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    handleDateChange={handleDateChange}
                />
                <Box sx={{
                    color: theme.palette.text.secondary,
                    mx: 2
                }}>
                    <CloseOutlinedIcon sx={{ cursor: 'pointer' }} fontSize="small"
                        onClick={() => {
                            setSelectedTime({ time: 'today', value: t('today') });
                            setIsCustom(false);
                        }}
                    />
                </Box>

            </Box>
    );
};

export default TimeDropdown;
